import React from 'react';
import { Layout } from 'react-admin';
import { connect } from 'react-redux';
import MyAppBar from './MyAppBar';
import MySideBar from './MySideBar';
import MyMenu from './MyMenu';
import { createMuiTheme } from '@material-ui/core/styles';

export const lightTheme = createMuiTheme({
    palette: {
        primary: {
            light: '#667dff',
            main: '#304ffe',
            dark: '#132066',
            contrastText: '#fff',
        },
        secondary: {
            light: '#f56295',
            main: '#f50057',
            dark: '#990036',
            contrastText: '#fff',
        },
    },
});

const MyLayout = props => (
    <Layout
        {...props}
        appBar={MyAppBar}
        sidebar={MySideBar}
        menu={MyMenu}
        //notification={MyNotification}
     />
);

export default connect(
    state => ({theme: lightTheme}),
    {}
)(MyLayout);